import {
  TERMINAL_TOGGLE_LOCK_REQUEST,
  TERMINAL_TOGGLE_LOCK_REQUEST_SUCCESS,
  TERMINAL_TOGGLE_LOCK_REQUEST_FAILURE,
  TERMINAL_TOGGLE_LOCK_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const terminalLocksReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case TERMINAL_TOGGLE_LOCK_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case TERMINAL_TOGGLE_LOCK_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case TERMINAL_TOGGLE_LOCK_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case TERMINAL_TOGGLE_LOCK_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default terminalLocksReducer;
